export default __webpack_public_path__ + "2105d45a64c815689fe01546ee3924ac.png";